import { makeAutoObservable, runInAction } from "mobx";
import { Supplier } from "../types";
import { apiService } from "../services/api";

class SupplierStore {
    suppliers: Supplier[] = [];
    currentSupplier: Supplier | null = null;
    loading = false;
    error: string | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    fetchSuppliers = async (): Promise<void> => {
        runInAction(() => {
            this.loading = true;
            this.error = null;
        });

        try {
            const suppliers = await apiService.getSuppliers();
            runInAction(() => {
                this.suppliers = suppliers;
                this.loading = false;
            });
        } catch (error: any) {
            runInAction(() => {
                this.error = error.response?.data?.message || "Ошибка загрузки поставщиков";
                this.loading = false;
            });
        }
    };

    setCurrentSupplier = (supplier: Supplier): void => {
        this.currentSupplier = supplier;
    };

    getSupplierById = (id: number): Supplier | undefined => {
        return this.suppliers.find((supplier) => supplier.id === id);
    };

    clearError = (): void => {
        this.error = null;
    };
}

export const supplierStore = new SupplierStore();
